import React from 'react'
import { withLazyRoute } from '@/components/Lazy/LazyRouteWrapper'

export const AdminListBuilder = withLazyRoute(
  React.lazy(() => import('./AdminListBuilder')),
  'Loading admin list builder...',
)

export const ListBuilder = withLazyRoute(
  React.lazy(() => import('./ListBuilder')),
  'Loading list builder...',
)

export const AdminFinancingHub = withLazyRoute(
  React.lazy(() => import('./Management/AdminFinancingHub')),
  'Loading admin financing hub...',
)

export const ClientFinancingDetail = withLazyRoute(
  React.lazy(() => import('./Management/AdminFinancingHub/ClientFinancingDetail')),
  'Loading client financing detail...',
)

export const CompanyFinancingDetail = withLazyRoute(
  React.lazy(() => import('./Management/AdminFinancingHub/CompanyFinancingDetail')),
  'Loading company financing detail...',
)

export const ApplicationManagement = withLazyRoute(
  React.lazy(() => import('./Management/ApplicationManagement')),
  'Loading application management...',
)

export const SubmissionManagement = withLazyRoute(
  React.lazy(() => import('./Management/SubmissionManagement')),
  'Loading submission management...',
)

export const BusinessSubmissionManagement = withLazyRoute(
  React.lazy(() => import('./Management/BusinessSubmissions')),
  'Loading business submission management...',
)

export const InventoryV3Management = withLazyRoute(
  React.lazy(() => import('./InventoryV3')),
  'Loading inventory v3...',
)

export const LeadManagement = withLazyRoute(
  React.lazy(() => import('./Management/LeadManagement')),
  'Loading lead management...',
)

export const ContactDetailPage = withLazyRoute(
  React.lazy(() => import('./Management/LeadManagement/ContactDetailPage')),
  'Loading contact...',
)

export const CompanyDetailPage = withLazyRoute(
  React.lazy(() => import('./Management/LeadManagement/CompanyDetailPage')),
  'Loading company...',
)

export const QuickLeadsPage = withLazyRoute(
  React.lazy(() => import('./Management/LeadManagement/QuickLeadsPage')),
  'Loading quick leads...',
)

export const TerminalManagement = withLazyRoute(
  React.lazy(() => import('./Management/TerminalManagement')),
  'Loading terminal management...',
)

export const TerminalDetailPage = withLazyRoute(
  React.lazy(() => import('./Management/TerminalManagement/TerminalDetailPage')),
  'Loading terminal...',
)

export const PhotoUpload = withLazyRoute(
  React.lazy(() => import('./Management/PhotoUpload')),
  'Loading photo upload...',
)

export const TransporterManagement = withLazyRoute(
  React.lazy(() => import('./Management/TransporterManagement')),
  'Loading transporter management...',
)

export const UserManagement = withLazyRoute(
  React.lazy(() => import('./Management/UserManagement')),
  'Loading user management...',
)

export const PickupLocations = withLazyRoute(
  React.lazy(() => import('./Management/PickupLocations')),
  'Loading pickup locations...',
)

export const ExpenseManagement = withLazyRoute(
  React.lazy(() => import('./Management/ExpenseManagement/ExpenseManagement')),
  'Loading expense management...',
)

export const InvoiceManagement = withLazyRoute(
  React.lazy(() => import('./Management/InvoiceManagement')),
  'Loading invoice management...',
)

export const TitleManager = withLazyRoute(
  React.lazy(() => import('./Management/TitleManager')),
  'Loading title manager...',
)

export const PartsManagement = withLazyRoute(
  React.lazy(() => import('./Management/PartsManagement')),
  'Loading parts management...',
)

export const SuperAdminHome = withLazyRoute(
  React.lazy(() => import('./SuperAdminHome')),
  'Loading super admin home...',
)

export const PerformanceReviews = withLazyRoute(
  React.lazy(() => import('./PerformanceReviews')),
  'Loading performance reviews...',
)

export const DealApproval = withLazyRoute(
  React.lazy(() => import('./DealApproval')),
  'Loading deal approval...',
)

export const ClientActivity = withLazyRoute(
  React.lazy(() => import('./ClientActivity')),
  'Loading client activity...',
)

export const TimeTracker = withLazyRoute(
  React.lazy(() => import('./TimeTracker/TimeTracker')),
  'Loading time tracker...',
)

export const PricingModels = withLazyRoute(
  React.lazy(() => import('./Tools/GrayBook/PricingModels')),
  'Loading pricing models...',
)

export const CategoryPricingDetail = withLazyRoute(
  React.lazy(() => import('./Tools/GrayBook/PricingModels/CategoryPricingDetail')),
  'Loading category pricing...',
)

export const ComparisonWorkbench = withLazyRoute(
  React.lazy(() => import('./Tools/GrayBook/PricingModels/ComparisonWorkbench')),
  'Loading comparison workbench...',
)

export * from './Tools'
